module.exports = __webpack_public_path__ + "static/lessons-0994d09f800fc67c6b6ff8cc051319e5.png";